<template>
  <div class='content' :class="visible ? 'content--visible' : ''">
      <h2>In the zone</h2>
      <p>
         <strong>Viewing the relationship by city area.</strong>
      </p>
      <p>
         Adding the specific travel time dimension and city area groupings highlight how postcodes in different parts of the city are spread or concentrated across these dimensions – and more or less price affected by their proximity to the CBD.
      </p>
      <p>
        For instance, the South Sydney area has rents ranging from approximately $350 to $500, despite the largest range of travel times (30-100mins) of any group.
      </p>
      <p>
        Some “coastal outlier” postcodes appear to be less affected by their lower public transport access – commanding much higher rents than the majority of postcodes at a similar proximity to the CBD.
      </p>
      <p>
        Select a single postcode to follow through the journey.
      </p>
      <multiselect 
        class="postcode__selector"
        :value="selectedPostcode" 
        :options="data" 
        track-by="postcode"
        label="label"
        @input="update_selected_postcode"
      ></multiselect>
  </div>
</template>

<script>
import tooltip_mixin from '@/assets/tooltip_mixin'
export default {
  props: {
    visible: {
        default: () => false
    }
  },
  mixins: [ tooltip_mixin ]
}
</script>

<style scoped>

.postcode__selector {
  width: 80%;
}

</style>
